import { useContext, useEffect } from "react";
import { CartContext } from "../../contexts/cart.context";
import { PopupContext } from "../../contexts/popup.context";
import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";
import {
  BackDiv,
  BuyButton,
  Closebtn,
  Imgcontqiner,
  ModalContent,
  Overlay,
  TextContainer,
} from "./product-popup.styles";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PopupProduct = () => {
  const { isPopupOpen, setIsPopupOpen, popupObject, addItemToPopup } =
    useContext(PopupContext);
  const { addItemToCart } = useContext(CartContext);
  const { name, price, imageUrl } = popupObject;
  const starRating = [
    "⭐⭐⭐ 3/5",
    "⭐⭐⭐⭐ 4/5",
    "⭐⭐⭐⭐⭐ 5/5",
    "⭐⭐ 2/5",
  ];
  const Randomrating =
    starRating[Math.floor(Math.random() * starRating.length)];

  const closePopUp = () => {
    setIsPopupOpen(!isPopupOpen);
    addItemToPopup(null);
  };

  const addProductToCart = () => {
    addItemToCart(popupObject);
    setIsPopupOpen(!isPopupOpen);
    toast.success("Product has been added to your cart!");
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "unset");
  }, []);

  if (!isPopupOpen) return null;

  return (
    <>
      <BackDiv>
        <Overlay>
          <ModalContent>
            <Imgcontqiner src={imageUrl} alt={`${name}`} />
            <TextContainer>
              <h1>{name}</h1>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo
                animi nesciunt repudiandae excepturi ipsum autem, similique iste
                veniam corporis natus enim non, hic deleniti impedit quaerat?
                Magni exercitationem quas, qui, earum maiores inventore atque
                dolore quo ab, praesentium a? Vitae qui optio quas iste repellat
                nemo quisquam modi impedit quis.
                <br />
                {Randomrating}
              </p>
              <h1>${price}</h1>
            </TextContainer>
            <BuyButton>
              <Button
                buttonType={BUTTON_TYPE_CLASSES.animated}
                onClick={addProductToCart}
              >
                Add to cart
              </Button>
            </BuyButton>
          </ModalContent>
          <Closebtn onClick={closePopUp}>X</Closebtn>
        </Overlay>
      </BackDiv>
      <ToastContainer />
    </>
  );
};

export default PopupProduct;
